import type { StepType } from '@reactour/tour';
import type { TourStepContext } from './types';

export const tenantsSteps = (_ctx: TourStepContext): StepType[] => [
  {
    selector: '[data-tour="tenants-header"]',
    content:
      'O gerenciamento de tenants é exclusivo do Super Admin. Cada tenant é uma organização independente com seus próprios usuários, projetos e configurações.',
  },
  {
    selector: '[data-tour="tenants-filters"]',
    content: 'Pesquise tenants pelo nome ou filtre por status (ativo/inativo) e plano.',
  },
  {
    selector: '[data-tour="tenants-new-btn"]',
    content:
      'Crie um novo tenant preenchendo nome, slug, e-mail do administrador e as features habilitadas. O sistema criará automaticamente o usuário administrador e enviará o convite por e-mail.',
  },
  {
    selector: '[data-tour="tenants-table"]',
    content:
      'A tabela lista todos os tenants com plano, status e data de criação. Clique nas ações para editar, visualizar logs de acesso ou desativar um tenant.',
  },
  {
    selector: '[data-tour="portfolio-ai-sidebar"]',
    content:
      'O item "Relatório IA — Portfólio" no menu Relatórios gera uma análise executiva completa do portfólio de projetos usando inteligência artificial. Disponível quando um tenant específico estiver selecionado.',
  },
];

export const cadastrosResponsaveisSteps = (_ctx: TourStepContext): StepType[] => [
  {
    selector: '[data-tour="responsaveis-header"]',
    content:
      'O cadastro de responsáveis mantém as informações dos gerentes e líderes que podem ser atribuídos a projetos. Mantenha esta lista atualizada para facilitar as atribuições.',
  },
  {
    selector: '[data-tour="responsaveis-table"]',
    content: 'Visualize e gerencie todos os responsáveis cadastrados.',
  },
];

export const cadastrosProgramasSteps = (_ctx: TourStepContext): StepType[] => [
  {
    selector: '[data-tour="programs-header"]',
    content:
      'Programas agrupam projetos relacionados que compartilham objetivos estratégicos comuns. Use para organizar o portfólio em iniciativas maiores.',
  },
  {
    selector: '[data-tour="programs-table"]',
    content: 'Visualize os programas existentes e os projetos vinculados a cada um.',
  },
];

export const cadastrosOkrsSteps = (_ctx: TourStepContext): StepType[] => [
  {
    selector: '[data-tour="okrs-header"]',
    content:
      'OKRs (Objectives and Key Results) conectam os projetos aos objetivos estratégicos da organização. Defina os Objetivos e seus Resultados-Chave aqui.',
  },
  {
    selector: '[data-tour="okrs-table"]',
    content:
      'Visualize o progresso de cada OKR e quais projetos estão contribuindo para cada objetivo.',
  },
];

export const okrDashboardSteps = (_ctx: TourStepContext): StepType[] => [
  {
    selector: '[data-tour="okr-dashboard-header"]',
    content:
      'O Dashboard OKR mostra o progresso consolidado de todos os Objetivos e Resultados-Chave. Verde indica meta atingida, amarelo em andamento, vermelho abaixo do esperado.',
  },
  {
    selector: '[data-tour="okr-dashboard-metrics"]',
    content:
      'Cada card representa um Resultado-Chave com seu percentual de atingimento e os projetos que contribuem para ele.',
  },
];

export const profileSteps = (_ctx: TourStepContext): StepType[] => [
  {
    selector: '[data-tour="profile-photo-card"]',
    content:
      'Clique na foto ou no botão "Alterar foto" para fazer o upload de uma nova foto de perfil. A foto aparece no header e nos cards de projeto.',
  },
  {
    selector: '[data-tour="profile-info-card"]',
    content:
      'Atualize seu nome, cargo, departamento, pronomes e fuso horário. Estas informações aparecem nos relatórios e notificações.',
  },
  {
    selector: '[data-tour="profile-password-card"]',
    content:
      'Altere sua senha aqui. Use uma senha forte com letras, números e símbolos para proteger sua conta.',
  },
  {
    selector: '[data-tour="profile-tour-reset"]',
    content:
      'Clique aqui para resetar os tutoriais de todas as páginas e vê-los novamente a qualquer momento.',
  },
];
